import { createContext, useContext, useMemo, type ReactNode } from 'react';
import { createContainer, type Container } from '../data/container';

const ContainerContext = createContext<Container | null>(null);

/**
 * Inyección de dependencias para la aplicación.
 *
 * Recibir el contenedor por props permite que las pruebas monten cualquier pantalla contra un
 * backend simulado propio, sin tocar el código de producción.
 */
export function ContainerProvider({
  children,
  container,
}: {
  children: ReactNode;
  container?: Container;
}) {
  const value = useMemo(() => container ?? createContainer(), [container]);
  return <ContainerContext.Provider value={value}>{children}</ContainerContext.Provider>;
}

export function useContainer(): Container {
  const container = useContext(ContainerContext);
  if (!container) throw new Error('useContainer debe usarse dentro de <ContainerProvider>');
  return container;
}
